export const STATUS_COLORS = {
  proposed: 'bg-muted text-muted-foreground',
  rfp_sent: 'bg-blue-100 text-blue-700',
  contracted: 'bg-violet-100 text-violet-700',
  in_progress: 'bg-emerald-100 text-emerald-700',
  on_hold_cancelled: 'bg-yellow-100 text-yellow-800',
  on_hold: 'bg-yellow-100 text-yellow-800',
  cancelled: 'bg-red-100 text-red-700',
  complete: 'bg-slate-100 text-slate-700',
  approved: 'bg-emerald-100 text-emerald-700',
  revises: 'bg-amber-100 text-amber-700',
  resubmit: 'bg-orange-100 text-orange-700',
  attention_required: 'bg-red-100 text-red-700',
};

export const STATUS_LABELS = {
  proposed: 'Proposed',
  rfp_sent: 'RFP Sent',
  contracted: 'Contracted',
  in_progress: 'In Progress',
  on_hold_cancelled: 'On Hold',
  on_hold: 'On Hold',
  cancelled: 'Canceled',
  complete: 'Complete',
  approved: 'Approved',
  revises: 'Revises',
  resubmit: 'Resubmit',
  attention_required: 'Attention Required',
};

export const TYPE_LABELS = {
  capital: 'Capital',
  moe: 'MOE',
  tenant: 'Tenant',
  /* Migration 024: an existing tenant's sign or remodel, opened by the
     Property Manager. See web/src/lib/tenantAlteration.js. */
  tenant_alteration: 'Tenant Alteration',
};

export const SIGNAGE_STATUS_COLORS = {
  draft: 'bg-muted text-muted-foreground',
  in_review: 'bg-amber-100 text-amber-700',
  revisions_required: 'bg-orange-100 text-orange-700',
  approved: 'bg-emerald-100 text-emerald-700',
  rejected: 'bg-red-100 text-red-700',
};

export const SIGNAGE_STATUS_LABELS = {
  draft: 'Draft',
  in_review: 'In Review',
  revisions_required: 'Revisions',
  approved: 'Approved',
  rejected: 'Rejected',
};